var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              path: "/delivery/DeliveryManagement/AddDelivery/add-delivery",
                            },
                          },
                        },
                        [
                          _c(
                            "b-button",
                            { attrs: { variant: "primary" } },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusIcon" },
                              }),
                              _vm._v(" New Delivery "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "my-1",
                      attrs: { cols: "12", md: "2", sm: "1" },
                    },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mb-2",
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.filteredDeliveries,
                          fields: _vm.deliveryFields,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection,
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "head(vehicleID)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Vehicle")]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Vehicle",
                                        size: "sm",
                                      },
                                      on: {
                                        input: function ($event) {
                                          _vm.currentPage = 1
                                        },
                                      },
                                      model: {
                                        value: _vm.filters.vehicle,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "vehicle", $$v)
                                        },
                                        expression: "filters.vehicle",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(pickUpLocation)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Pickup Location")]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Pickup Location",
                                        size: "sm",
                                      },
                                      on: {
                                        input: function ($event) {
                                          _vm.currentPage = 1
                                        },
                                      },
                                      model: {
                                        value: _vm.filters.pickup,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "pickup", $$v)
                                        },
                                        expression: "filters.pickup",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(dropOffLocation)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Dropoff Location")]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Dropoff Location",
                                        size: "sm",
                                      },
                                      on: {
                                        input: function ($event) {
                                          _vm.currentPage = 1
                                        },
                                      },
                                      model: {
                                        value: _vm.filters.dropoff,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "dropoff", $$v)
                                        },
                                        expression: "filters.dropoff",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(deliveryStatus)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Delivery Status")]),
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.statusOptions,
                                        size: "sm",
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.currentPage = 1
                                        },
                                      },
                                      model: {
                                        value: _vm.filters.status,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "status", $$v)
                                        },
                                        expression: "filters.status",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(note)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Notes")]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Notes",
                                        size: "sm",
                                      },
                                      on: {
                                        input: function ($event) {
                                          _vm.currentPage = 1
                                        },
                                      },
                                      model: {
                                        value: _vm.filters.note,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "note", $$v)
                                        },
                                        expression: "filters.note",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(vehicleID)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getVehiclemake(data.item.vehicleID)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(driverID)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getDriverName(data.item.driverID)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(deliveryStatus)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant: _vm.statusVariants[data.value],
                                    },
                                  },
                                  [_vm._v(_vm._s(data.value))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          to: {
                                            name: "view-delivery",
                                            params: { id: data.item.id },
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EyeIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("View")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          to: {
                                            name: "edit-delivery",
                                            params: { id: data.item.id },
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EditIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("Edit")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          disabled:
                                            data.item.deliveryStatus ===
                                            "DELIVERED",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmDeleteDelivery(
                                              data.item.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "TrashIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("Delete")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center mb-1" },
                        [
                          _vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center mb-1",
                                },
                                [
                                  _c("b-spinner", {
                                    staticStyle: {
                                      width: "3rem",
                                      height: "3rem",
                                    },
                                    attrs: {
                                      variant: "success",
                                      label: "Spinning",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.filteredDeliveries.length,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }